import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { withStyles } from '@mui/styles';

const styles = {
  expansionPanelIconStyle: {
    fontSize: 30,
    color: '#545454',
  },
  expansionPanelSummaryStyle: {
    color: '#545454',
  },
};

const ExpansionPanel = withStyles({
  root: {
    left: 0,
    boxShadow: 'none',
    borderTop: '1px solid #ccc',
    borderBottom: '1px solid #ccc',
    width: '100%',
  },
})(Accordion);

const ExpansionPanelSummary = withStyles({
  root: {
    padding: '0 24px 0 8px',
    justifyContent: 'flex-start',
  },
  content: {
    flexGrow: 'unset',
  },
})(AccordionSummary);

const ExpansionPanelDetails = withStyles({
  root: {
    padding: '0 8px 8px 8px',
  },
})(AccordionDetails);

export function SearchQueryExpression({ expression }) {
  return (
    <ExpansionPanel square>
      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon style={styles.expansionPanelIconStyle} />}>
        <b style={styles.expansionPanelSummaryStyle}>Search Expression</b>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>
        {expression.length > 0 ? expression : 'Expression is empty'}
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
}
